export const REFERRAL_STATUS = {
  USER_SIGNED_UP: 1,
  USER_VERIFIED: 2,
  FIRST_LISTING_PUBLISHED: 3,
  FIRST_BOOKING_REQUEST_SENT: 4,
  FIRST_BOOKING_COMPLETED: 5,
  PURCHASED: 6,
  LISTED_OR_REQUESTED_PROPERTY: 7,
};
